import { api } from "@/lib/api";
import type { ScopedParams } from "./common";
import type { MatchDto, MatchTipsResponse, SubmitTipRequest, ToggleTutiRequest } from "@/types/api";

export const matchesApi = {
  list: ({ leagueId, tournamentId }: ScopedParams) =>
    api.get<MatchDto[]>("/api/matches", { leagueId, tournamentId }),
  matchTips: (matchId: string, { leagueId, tournamentId }: ScopedParams) =>
    api.get<MatchTipsResponse>(`/api/matches/${matchId}/tips`, { leagueId, tournamentId }),
  submitTip: (body: SubmitTipRequest) => api.post<{ success: boolean }>("/api/tips", body),
  toggleTuti: (body: ToggleTutiRequest) => api.post<{ success: boolean }>("/api/tips/tuti", body),
};
